import React from "react";
import { FormProps } from "./Form.types";
import { Default } from "./variations/Default";

export const Form: React.FC<FormProps> = (props) => {
  switch (props.variation) {
    default:
      return <Default {...props} />;
  }
};
